import { mainColor } from "assets/styleUtils";
import * as React from "react";

const SvgLogoNoback = ({ color = mainColor }) => (
  <svg
    id="cls-1"
    data-name="cls-1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 464.67 464.67"
    fill={color}
  >
    <path
      className="cls-1"
      d="M232.34.25C104.36.25.25,104.36.25,232.34s104.11,232.09,232.09,232.09,232.09-104.11,232.09-232.09S360.31.25,232.34.25ZM190.04,434.9l152.78-152.78v125.04c-31.99,20.29-69.87,32.09-110.48,32.09-14.49,0-28.64-1.51-42.3-4.36ZM367.98,388.4v-136.65l-21.47-8.89-184.19,184.19c-14.18-5.12-27.63-11.76-40.19-19.7v-125.22l63.17,63.17,17.79-17.79-84.65-84.65-21.47,8.89v136.89c-43.78-37.97-71.56-93.94-71.56-156.3C25.41,118.24,118.24,25.41,232.34,25.41s206.93,92.83,206.93,206.93c0,62.24-27.66,118.1-71.28,156.07Z"
    />
    <path
      className="cls-1"
      d="M300.89,82.29h-137.1l-8.89,3.68-58.53,58.52v17.79l127.07,127.07h17.79l127.07-127.07v-17.79l-58.52-58.52-8.89-3.69ZM181.84,107.45h100.98l-50.49,136.71-50.49-136.71ZM158.79,117.66l41.86,113.33-77.6-77.6,35.74-35.74ZM264.02,230.99l41.86-113.33,35.74,35.74-77.6,77.6Z"
    />
  </svg>
);
export default SvgLogoNoback;
